import { useParams } from "@tanstack/react-router";
import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { shopBreadcrumbs } from "@/modules/merchant/presentation/lib/shop-breadcrumb";
import { PosSalesByBranchReportSection } from "@/modules/merchant/presentation/ui/PosSalesByBranchReportSection";
import { RequireMerchantPermission } from "@/modules/merchant/presentation/ui/RequireMerchantPermission";
import { MerchantPermissions } from "@/modules/roles/domain/contracts/merchant-permissions";
import { Breadcrumb } from "@/shared/ui/Breadcrumb";

export function ShopReportsBranchesPage() {
  const params = useParams({ strict: false });
  const shopId = params?.shopId as string | undefined;

  return (
    <RequireMerchantPermission permission={MerchantPermissions.pos.read}>
      <Header>
        <Breadcrumb items={shopBreadcrumbs.reportsBranches(shopId)} />
      </Header>
      <Main>
        <div className="mb-4">
          <h1 className="font-heading font-semibold text-foreground text-xl">
            ຍອດຂາຍແຍກສາຂາ
          </h1>
          <p className="mt-1 text-muted-foreground text-sm">
            ເປຣຢີບຽບສາຂາຕາມຊ່ວງວັນທີ — ເປີດ multi_branch ໃນການຕັ້ງຮ້ານ
          </p>
        </div>
        <PosSalesByBranchReportSection shopId={shopId} />
      </Main>
    </RequireMerchantPermission>
  );
}
